import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { iBisAuthService } from '@dohu/ibis-auth';

export const quotationAccessGuard: CanActivateFn = () => {
  const auth = inject(iBisAuthService);
  const router = inject(Router);

  if (auth.isAuth && !auth.hasRole('support')) {
    router.navigateByUrl('/rfq-item');
    return false;
  }
  return true;
};
